import { AdditionRestChargeInfo } from "../types/AdditionRestChargeTypes";
import "./ProductModal.scss";
import { useCommonUtil } from "../util/useCommonUtil";
import SvgIcon from "@mui/material/SvgIcon";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import React from "react";
interface productProps {
  detail: AdditionRestChargeInfo[] | undefined;
  onClose: () => void;
}

const ProductModal: React.FC<productProps> = ({ detail, onClose }) => {
  const { formatNumber } = useCommonUtil();

  const addLineBreaks = (text: string) => {
    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  return (
    <>
      <div className="prod-overlay">
        <div className="prod-container">
          <div className="prod-header">
            <div
              style={{
                width: "100%",
                fontWeight: "700",
                fontSize: "2em",
                textAlign: "center",
                borderBottom: "2px solid #e4e7ec",
                lineHeight: 2.5,
              }}
            >
              기타상품 상세
            </div>
            <SvgIcon
              component={CloseOutlinedIcon}
              style={{
                position: "absolute",
                fontSize: "3em",
                right: "3%",
                top: "30px",
              }}
              onClick={onClose}
            ></SvgIcon>
          </div>

          <div className="prod-background-wrap">
            <div className="prod-background">
              {detail?.map((item: AdditionRestChargeInfo, idx: number) => (
                <div className="prod-detail-wrap">
                  <div className="prod-name">
                    <span className="name">
                      {item.restChargeInfo.productName}
                    </span>
                    <span className="etc">
                      {item.restChargeInfo.etc
                        ? addLineBreaks(item.restChargeInfo.etc)
                        : "설명 없음"}
                    </span>
                  </div>
                  <div className="price">
                    {formatNumber(item.chargeRequester)}원
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className="arrow-wrap"
            style={{
              position: "relative",
              zIndex: "9999",
              borderBottom: "0",
            }}
          >
            <SvgIcon
              component={KeyboardArrowUpOutlinedIcon}
              style={{
                fontSize: "8em",
                marginRight: "30px",
                color: "#e4e7ec",
              }}
            ></SvgIcon>
            <SvgIcon
              component={KeyboardArrowDownOutlinedIcon}
              style={{
                fontSize: "8em",
                color: detail && detail?.length > 5 ? "#3E83F1" : "#e4e7ec",
              }}
            ></SvgIcon>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductModal;
